import { useResetRecoilState } from "recoil";
import { cartState, browseBannerState, scheduleState } from "atoms";

type ResetFunction = () => void;

const useResetMultipleStates = (): ResetFunction => {
  const resetCart: ResetFunction = useResetRecoilState(cartState);
  const resetBrowseBanner: ResetFunction = useResetRecoilState(browseBannerState);
  const resetSchedule: ResetFunction = useResetRecoilState(scheduleState);

  const resetAllStates: ResetFunction = () => {
    resetCart();
    resetBrowseBanner();
    resetSchedule();
  };

  return resetAllStates;
};

export default useResetMultipleStates;
